import pages from './pages';

export const isOnDashboard = (pathname: string) =>
  pathname === pages.HOME_PAGE.path;
